import React, { useEffect, useState, useMemo } from 'react';
import { Heart, Sparkles, Flower2, Star } from 'lucide-react';
import MetaTags from '@/components/MetaTags';
const WomensDay = () => {
    const [isOpen, setIsOpen] = useState(false);
    const [showContent, setShowContent] = useState(false);
    const heartPositions = useMemo(() => Array.from({ length: 12 }, () => ({
        left: Math.random() * 100,
        top: Math.random() * 100,
        delay: Math.random() * 5,
        duration: 3 + Math.random() * 4,
    })), []);
    const starPositions = useMemo(() => Array.from({ length: 8 }, () => ({
        left: Math.random() * 100,
        top: Math.random() * 100,
        delay: Math.random() * 4,
        duration: 4 + Math.random() * 3,
    })), []);
    const sparklePositions = useMemo(() => Array.from({ length: 15 }, () => ({
        left: Math.random() * 100,
        top: Math.random() * 100,
        delay: Math.random() * 3,
        duration: 1 + Math.random() * 2,
    })), []);
    useEffect(() => {
        const timer1 = setTimeout(() => setIsOpen(true), 300);
        const timer2 = setTimeout(() => setShowContent(true), 1000);
        return () => {
            clearTimeout(timer1);
            clearTimeout(timer2);
        };
    }, []);
    return (<div className="min-h-[100dvh] overflow-hidden bg-gradient-to-br from-pink-50 via-purple-50 to-rose-100 relative">
      <MetaTags title="روز زن مبارک | آزمایشگاه‌های سلامت و شکوه" description="تبریک روز زن از مجموعه آزمایشگاه‌های سلامت و شکوه" keywords="روز زن, تبریک روز زن, زنان پزشک, آزمایشگاه سلامت" path="/womens-day"/>
      
      
      <div className="absolute inset-0 overflow-hidden pointer-events-none">
        
        {heartPositions.map((pos, i) => (<div key={i} className="absolute animate-float hidden sm:block" style={{
                left: `${pos.left}%`,
                top: `${pos.top}%`,
                animationDelay: `${pos.delay}s`,
                animationDuration: `${pos.duration}s`,
            }}>
            <Heart className="w-3 h-3 sm:w-4 sm:h-4 text-pink-300 opacity-60" fill="currentColor"/>
          </div>))}
        
        
        {starPositions.map((pos, i) => (<div key={`star-${i}`} className="absolute animate-float hidden sm:block" style={{
                left: `${pos.left}%`,
                top: `${pos.top}%`,
                animationDelay: `${pos.delay}s`,
                animationDuration: `${pos.duration}s`,
            }}>
            <Star className="w-2 h-2 sm:w-3 sm:h-3 text-purple-300 opacity-50" fill="currentColor"/>
          </div>))}
        
        
        <div className="absolute top-10 left-5 sm:top-20 sm:left-10 w-48 h-48 sm:w-72 sm:h-72 bg-pink-300 rounded-full mix-blend-multiply filter blur-xl sm:blur-2xl opacity-20 sm:opacity-30 animate-blob"></div>
        <div className="absolute top-20 right-5 sm:top-40 sm:right-10 w-48 h-48 sm:w-72 sm:h-72 bg-purple-300 rounded-full mix-blend-multiply filter blur-xl sm:blur-2xl opacity-20 sm:opacity-30 animate-blob animation-delay-2000"></div>
        <div className="absolute -bottom-8 left-1/2 w-48 h-48 sm:w-72 sm:h-72 bg-rose-300 rounded-full mix-blend-multiply filter blur-xl sm:blur-2xl opacity-20 sm:opacity-30 animate-blob animation-delay-4000"></div>
      </div>

      
      <div className="min-h-[100dvh] flex items-center justify-center p-3 sm:p-4 relative z-10 py-6">
        <div className={`relative w-full max-w-4xl transition-all duration-1000 ease-out ${isOpen ? 'scale-100 opacity-100' : 'scale-95 opacity-0'}`}>
          
          <div className="relative bg-white/95 sm:bg-white/90 backdrop-blur-md sm:backdrop-blur-lg rounded-2xl sm:rounded-3xl shadow-xl sm:shadow-2xl overflow-hidden border border-white/50">
            
            <div className="h-1.5 sm:h-2 bg-gradient-to-r from-pink-400 via-purple-400 to-rose-400"></div>
            
            
            <div className="p-5 sm:p-8 md:p-12">
              
              <div className="text-center mb-6 sm:mb-8 animate-fade-in-up">
                <div className="inline-flex items-center justify-center w-16 h-16 sm:w-20 sm:h-20 md:w-24 md:h-24 rounded-full bg-gradient-to-br from-pink-400 to-purple-500 mb-4 sm:mb-6 shadow-lg animate-pulse-scale">
                  <Flower2 className="w-8 h-8 sm:w-10 sm:h-10 md:w-12 md:h-12 text-white"/>
                </div>
                <h1 className="text-3xl sm:text-4xl md:text-5xl font-bold bg-gradient-to-r from-pink-600 via-purple-600 to-rose-600 bg-clip-text text-transparent mb-3 sm:mb-4 leading-tight">
                  روز زن مبارک
                </h1>
                <div className="flex items-center justify-center gap-1.5 sm:gap-2 text-pink-500 mb-4 sm:mb-6">
                  <Sparkles className="w-4 h-4 sm:w-5 sm:h-5 md:w-6 md:h-6 animate-pulse"/>
                  <span className="text-base sm:text-lg font-semibold">تبریک ویژه</span>
                  <Sparkles className="w-4 h-4 sm:w-5 sm:h-5 md:w-6 md:h-6 animate-pulse"/>
                </div>
              </div>

              
              <div className={`space-y-4 sm:space-y-6 text-center transition-all duration-1000 delay-500 ${showContent
            ? 'opacity-100 translate-y-0'
            : 'opacity-0 translate-y-8'}`}>
                <div className="article-prose prose prose-sm sm:prose-base md:prose-lg max-w-none text-gray-700 leading-relaxed sm:leading-loose">
                  <p className="text-base sm:text-lg md:text-xl lg:text-2xl font-medium mb-4 sm:mb-6 text-gray-800 px-1">
                    تلفیق "دانش پزشکی" با "درایت و صبر زنانه"، هنری است که شما به زیبایی آن را به تصویر کشیده‌اید.
                  </p>
                  
                  <p className="text-sm sm:text-base md:text-lg lg:text-xl mb-4 sm:mb-6 text-gray-700 px-1">
                    حضور شما در جامعه پزشکی، نه تنها ضامن سلامت جسم، بلکه نویدبخش آرامش و امید است.
                  </p>
                  
                  <div className="my-6 sm:my-8 flex items-center justify-center gap-3 sm:gap-4">
                    <div className="h-px flex-1 bg-gradient-to-r from-transparent via-pink-300 to-transparent"></div>
                    <Heart className="w-5 h-5 sm:w-6 sm:h-6 text-pink-500 animate-pulse flex-shrink-0" fill="currentColor"/>
                    <div className="h-px flex-1 bg-gradient-to-r from-transparent via-pink-300 to-transparent"></div>
                  </div>
                  
                  <p className="text-sm sm:text-base md:text-lg lg:text-xl font-semibold text-purple-700 mt-6 sm:mt-8 px-1">
                    از طرف مجموعه آزمایشگاه‌های سلامت و شکوه، روز زن را به شما تبریک عرض می‌نماییم و قدردان زحمات بی‌دریغتان هستیم.
                  </p>
                </div>
              </div>

              
              <div className={`mt-8 sm:mt-12 pt-6 sm:pt-8 border-t border-gray-200 text-center transition-all duration-1000 delay-700 ${showContent
            ? 'opacity-100 translate-y-0'
            : 'opacity-0 translate-y-8'}`}>
                <p className="text-xs sm:text-sm text-gray-500 mb-1.5 sm:mb-2">از طرف</p>
                <p className="text-xl sm:text-2xl md:text-3xl font-bold bg-gradient-to-r from-pink-600 via-purple-600 to-rose-600 bg-clip-text text-transparent break-all sm:break-normal">
                  salamatlab.com
                </p>
                <p className="text-sm sm:text-base md:text-lg text-gray-600 mt-1.5 sm:mt-2 font-medium px-2">
                  آزمایشگاه‌های سلامت و شکوه
                </p>
              </div>
            </div>

            
            <div className="hidden sm:block absolute top-4 right-4 w-12 h-12 md:w-16 md:h-16 opacity-20">
              <div className="absolute inset-0 border-2 md:border-4 border-pink-400 rounded-tl-3xl rounded-br-3xl"></div>
            </div>
            <div className="hidden sm:block absolute bottom-4 left-4 w-12 h-12 md:w-16 md:h-16 opacity-20">
              <div className="absolute inset-0 border-2 md:border-4 border-purple-400 rounded-tr-3xl rounded-bl-3xl"></div>
            </div>
          </div>

          
          <div className="absolute -top-4 -right-4 sm:-top-8 sm:-right-8 w-16 h-16 sm:w-24 sm:h-24 bg-pink-200 rounded-full blur-xl sm:blur-2xl opacity-30 sm:opacity-40 animate-float"></div>
          <div className="absolute -bottom-4 -left-4 sm:-bottom-8 sm:-left-8 w-20 h-20 sm:w-32 sm:h-32 bg-purple-200 rounded-full blur-xl sm:blur-2xl opacity-30 sm:opacity-40 animate-float animation-delay-2000"></div>
        </div>
      </div>

      
      <div className="absolute inset-0 pointer-events-none overflow-hidden">
        {sparklePositions.map((pos, i) => (<div key={`sparkle-${i}`} className="absolute w-0.5 h-0.5 sm:w-1 sm:h-1 bg-pink-400 rounded-full animate-pulse" style={{
                left: `${pos.left}%`,
                top: `${pos.top}%`,
                animationDelay: `${pos.delay}s`,
                animationDuration: `${pos.duration}s`,
            }}></div>))}
      </div>
    </div>);
};
export default WomensDay;
